import { webConfig } from './webConfig';

/**
 * Return the fully qualified realtime channels url with protocol.
 */
export function getChannelsEndpoint(): string {
    return `https://${webConfig.services.channels.host}`;
}
